// CommonReportComponent.js
import React from 'react';
import { CommonPageHeading } from '../CommonHeading/CommonPageHeading';
import { CommonReactTable } from '../CommonTable/CommonReactTable';

const CommonReportComponent = ({
  showDrillCount, showData,
  showAbstractData, columns,
  AbstractColumns, level0Heading, level1Heading,
  headerNameLevel0,
  headerNameLevel1,
  showFooterLevel0 = true,
  showFooterLevel1 = false,
  paginationLevel0 = "false",
  paginationLevel1 = "true",
  isBackFunction = () => { },
}) => {
  return (
    <div>
      {showDrillCount === 0 && (
        <>
          <CommonPageHeading heading={level0Heading} back={false} />
          {showData?.length > 0 ? (
            <div className="table-responsive">
              <CommonReactTable
                tableid='selected-id'
                data={showData}
                columns={columns}
                serachAlign="left"
                headerName={headerNameLevel0}
                headColumCount={24}
                pagination={paginationLevel0}
                search="true"
                showFooter={showFooterLevel0.toString()}
                filename="Report"
                paginationCount="All"
              />
            </div>
          ) : (
            <div className="text-error text-center">*** No Data Found***</div>
          )}
        </>
      )}
      {showDrillCount === 1 && (
        <>
          <CommonPageHeading heading={level1Heading} back={false} />
          {showAbstractData?.length > 0 ? (
            <div className="table-responsive">
              <CommonReactTable
                tableid='selected-id'
                data={showAbstractData}
                columns={AbstractColumns}
                serachAlign="left"
                isBack={true}
                isBackFunction={isBackFunction}
                headerName={headerNameLevel1}
                headColumCount={20}
                pagination={paginationLevel1}
                search="true"
                showFooter={showFooterLevel1.toString()}
                filename="Report"
              />
            </div>
          ) : (
            <div className="text-error text-center">*** No Data Found***</div>
          )}
        </>
      )}
    </div>
  );
};

export default CommonReportComponent;